var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E5E7DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23319_43259)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6655 5.89699H12.3578C11.4504 5.89464 10.5537 6.10702 9.74239 6.51684C7.76471 7.50524 6.51356 9.52839 6.5127 11.7419L6.51658 11.9685C6.54155 12.6475 6.68651 13.3168 6.94416 13.9452L7.01969 14.1196L5.929 17.3927L5.91091 17.4581C5.81032 17.914 6.24814 18.324 6.70727 18.171L9.97979 17.0797L10.1548 17.1558C10.853 17.4421 11.602 17.5893 12.3594 17.5873C14.5716 17.5864 16.5947 16.3353 17.5843 14.3553C17.993 13.5462 18.2053 12.6496 18.203 11.7406L18.203 11.4345C18.0413 8.48766 15.755 6.14973 12.8637 5.90929L12.6655 5.89699ZM12.3565 7.12743L12.6399 7.12683L12.6318 7.1265C14.9741 7.25573 16.8444 9.126 16.9736 11.4683L16.9727 11.742C16.9745 12.4588 16.8074 13.1643 16.485 13.8027C15.7026 15.3682 14.1053 16.3559 12.3578 16.3566C11.6413 16.3585 10.9358 16.1914 10.2974 15.8689L10.2224 15.8371C10.0947 15.7926 9.95514 15.7912 9.82544 15.8344L7.48507 16.6144L8.26566 14.2747C8.31754 14.119 8.30511 13.9491 8.23115 13.8027C7.90871 13.1643 7.74162 12.4588 7.74348 11.7436C7.74416 9.99475 8.73191 8.39753 10.2951 7.61629C10.9358 7.29268 11.6413 7.12558 12.3565 7.12743Z",
    fill: "#587E85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23319_43259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotCommentIcon);
export default __webpack_public_path__ + "static/media/chatbot_comment_icon.a20e771791d0fdc7860267dffd154a86.svg";
export { ForwardRef as ReactComponent };